import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { AppState } from '../_reducers';
import { environment } from '../../../environments/environment';
import { Employee } from '../_models';
import { selectAllEmployees } from '../_selectors/employee.selectors';

@Injectable()
export class EmployeeService {
  private apiBaseUrl = environment.apiBaseUrl;
  employeeList$: Observable<Employee[]>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private translate: TranslateService
  ) {
    this.employeeList$ = this.store.pipe(select(selectAllEmployees));
  }

  getFromLocalStore(): Observable<Employee[]> {
    return this.employeeList$;
  }

  getEmployees(): Observable<Employee[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v2/employees').pipe(
      map((response) => {
        return this.manageRemovedEmployee(response);
      })
    );
  }

  getEmployee(id: number): Observable<Employee> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v2/employees/' + id)
      .pipe(map((response) => response));
  }

  saveEmployee(employeeItem): Observable<Employee> {
    const employee = { ...employeeItem };
    delete employee.lastUpdated;
    delete employee.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    employee.companyId = companySelected ? companySelected.id : null;

    if (employee.user != null && employee.user.id != null) {
      employee.user = { id: employee.user.id };
    }
    if (employee.id) {
      return this.http
        .put<Employee>(this.apiBaseUrl + 'api/private/v2/employees/' + employee.id, employee)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Employee>(this.apiBaseUrl + 'api/private/v2/employees/', employee)
        .pipe(map((response) => response));
    }
  }

  saveEmployeeBadge(employee): Observable<Employee> {
    delete employee.lastUpdated;
    delete employee.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    employee.companyId = companySelected ? companySelected.id : null;

    if (employee.user != null && employee.user.id != null) {
      employee.user = { id: employee.user.id };
    }
    return this.http
      .put<Employee>(this.apiBaseUrl + 'api/private/v1/employeeDevices/' + employee.id, employee)
      .pipe(map((response) => response));
  }

  deleteEmployee(id: number): Observable<Employee> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v2/employees/' + id).pipe(
      map((response) => {
        return { id } as Employee;
      })
    );
  }

  getEmployeesOPModule(farmsAppend): Observable<Employee[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v2/employees/' + farmsAppend).pipe(
      map((response) => {
        return this.manageRemovedEmployee(response);
      })
    );
  }

  manageRemovedEmployee(allEmployeeList) {
    allEmployeeList.forEach((i) => {
      if (i.deleted == true) {
        i.lastName =
          i.lastName +
          ' - (' +
          this.translate.instant('users_select.remove_on', {}) +
          ' ' +
          moment(i.lastUpdated.toString()).utc().format('DD-MM-YYYY') +
          ')';
      }
    });
    return allEmployeeList;
  }
}
